import Lenis from 'lenis'
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

/**
 * Клас для управління прокручуванням сторінки.
 * 
 * @package AGDS
 * @category Modules
 * @module Scroll
 * @see AGDSApp
 * @author Andy Groove
 * @since 1.0.0
 */
export default class Scroll {

	/**
	 * Конструктор
	 *
	 * @param {Object} options
	 */
	constructor(options = {}) {
		this.header = options.header
		this.windowWidth = options.windowWidth
	}

	/**
	 * Ініціалізація
	 * 
	 * @returns {void}
	 */
	init() {



		// Lenis
		this.lenisSmoothScrollInit()

		// Плавне прокручування до посилань
		this.smoothScrollToAnchor()
	}

	/**
	 * Lenis - Smooth scroll
	 */
	lenisSmoothScrollInit() {
		if (typeof Lenis === 'undefined'
			|| typeof gsap === 'undefined'
			|| typeof ScrollTrigger === 'undefined'
		) return

		scroll = new Lenis()
		scroll.on('scroll', ScrollTrigger.update)

		gsap.ticker.add((time) => {
			scroll.raf(time * 1000)
		})

		gsap.ticker.lagSmoothing(0)

		// Оновлення ScrollTrigger
		ScrollTrigger.refresh()
	}

	/**
	 * Плавне прокручування до посилань.
	 * Враховує висоту хедера при прокрутці.
	 * 
	 * @returns {void}
	 */
	smoothScrollToAnchor() {
		const anchorLinks = document.querySelectorAll('a[href*="#"]:not([data-fancybox])')
		if (!anchorLinks.length) return

		anchorLinks.forEach(anchor => {
			anchor.addEventListener('click', event => {
				const href = anchor.getAttribute('href')
				const hash = href.split('#')[1]

				// Перевірка на наявність елемента з відповідним id
				if (hash && document.getElementById(hash)) {
					event.preventDefault()
					const headerHeight = this.header ? this.header.offsetHeight : 0
					const targetOffset = document.getElementById(hash).offsetTop - headerHeight
					this.scrollToWindowTop(targetOffset)
				}
			})
		})
	}

	/**
	 * Скролл до верху сторінки.
	 * 
	 * @param {number} top - Висота скроллу
	 * @returns {void}
	 */
	scrollToWindowTop(top = 0) {
		window.scrollTo({
			top,
			behavior: 'smooth'
		})
	}
}
